import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import {COUNTRIES} from "../utils/country";
import {useTranslation} from "react-i18next";

const CountrySelect = props => {
  const { t } = useTranslation('country_select');
  const [value, setValue] = React.useState(props.value);

  const options = COUNTRIES.map(countryCode => ({
    label: <span>
      <span className={`fi fi-${countryCode.toLowerCase()}`} />
      <span className="ml-1">{t(`country:${countryCode}`)}</span>
    </span>,
    name: t(`country:${countryCode}`),
    value: countryCode,
  }));

  return <Select
    classNamePrefix="react-select"
    className="w-100"
    placeholder={t('placeholder')}
    options={options}
    filterOption={(option, input) => {
      if(!input){
        return true
      }
      return option.data.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }}
    value={options.find(option => option.value === value)}
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />;
};

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CountrySelect;
